<template>
    <div class="enameledWireMateBarBind">
        <m-assembly-table :formData="formData"
                        :columns="tableColumns"
                        :data="tableData"
                        :currentPage="settings.currentPage"
                        :pageSize="settings.pageSize"
                        :settings="settings"
                        :tableButtons="tableButtons"
                        :tableTitle="tableTitle"
                        :loading="loading"
                        :total="settings.total"
                        :height="500"
                        @onSubmit="onSubmit"
                        @onPageSizeChange="onPageSizeChange"
                        @onCurrentPageChange="onPageChange"
                        @onSelectionChange="onSelectionChange"
                        ref="mateForm">
        </m-assembly-table>
    </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import mAssemblyTable from '@/components/awesome/page/assembly_table/index.js';
export default {
    name: 'enameledWireMateBarBind',
    components: {mAssemblyTable},
    data() {
        return {
            itemTagBarcodeVal: '',
            supplierInfo: {},
            settings: {
                needPager: false,
                showElevator: true,
                showSizer: true,
                pageSizeOpts: [20, 50, 80, 100],
                needSearch: true,
                needValidation: true,
                currentPage: 1,
                pageSize: 20,
                total: 0
            },
            formData: {
                row: 1,
                items: [
                    {
                        placeholder: this.$t('enameledWireMateBarBind.t1'), // 请选择送货单条码号
                        title: this.$t('enameledWireMateBarBind.t2'), // 送货单条码号
                        value: '',
                        field: 'deliveryBarcode',
                        disabled: false,
                        validators: {
                            required: {
                                required: true,
                                message: this.$t('enameledWireMateBarBind.t3') // 组织不能为空
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t4'),
                        value: '',
                        field: 'deliveryQuantity',
                        disabled: true,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t5'),
                        value: '',
                        field: 'quantity',
                        disabled: true,
                        validators: {
                            required: {
                                required: false
                            }
                        },
                        layout: {
                            span: 8,
                            offset: 0,
                            row: 1
                        },
                        options: {
                            rows: 1,
                            type: 'text'
                        },
                        type: 'text'
                    }
                ],
                buttons: {
                    showSubmit: true,
                    showReset: true,
                    showSearch: true,
                    layout: {
                        span: 24,
                        push: 8
                    }
                }
            },
            tableButtons: {
                systemButtons: [],
                customButtons: [
                    {
                        name: '',
                        label: this.$t('enameledWireMateBarBind.t6'), // 绑定
                        type: 'primary',
                        icon: 'ios-down',
                        loading: false,
                        disabled: true,
                        click: (button) => {
                            this.beforeBindingBarcode(button);
                        }
                    }
                ]
            },
            tableColumns: {
                columns: [
                    {
                        title: this.$t('enameledWireMateBarBind.t7'),
                        type: 'selection',
                        width: 30,
                        align: 'center'
                    },
                    {
                        renderHeader: (h, params) => {
                            return h('div', {
                                style: {
                                    display: 'inline-block'
                                }
                            }, [
                                h('Row', {
                                    style: {
                                        height: '28px',
                                        lineHeight: '28px'
                                    }
                                }, [
                                    h('Input', {
                                        props: {
                                            size: 'small',
                                            value: this.itemTagBarcodeVal.trim()
                                        },
                                        on: {
                                            'on-change': (evnet) => {
                                                console.log('evnet::', evnet);
                                                this.itemTagBarcodeVal = event.target.value;
                                                this.filterData();
                                            }
                                        }
                                    })
                                ]),
                                h('Row', {
                                    style: {
                                        height: '20px',
                                        lineHeight: '19px'
                                    }
                                }, [
                                    h('div', {}, this.$t('enameledWireMateBarBind.t8'))
                                ])]);
                        },
                        title: this.$t('enameledWireMateBarBind.t8'),
                        key: 'itemTagBarcode',
                        align: 'left',
                        tooltip: true,
                        sortable: true,
                        minWidth: 120
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t9'), // 内箱[内桶]条码号
                        key: 'innerTagBarcode',
                        align: 'left',
                        tooltip: true,
                        sortable: true,
                        minWidth: 120
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t10'), // 物料编码
                        key: 'itemCode',
                        align: 'left',
                        tooltip: true,
                        minWidth: 130
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t11'), // 数量
                        key: 'quantity',
                        align: 'right',
                        sortable: true,
                        minWidth: 90
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t12'), // [物料]批次
                        key: 'itemBatch',
                        align: 'center',
                        sortable: true,
                        minWidth: 70
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t13'), // 轴重/轴数
                        key: 'rollerQuantity',
                        align: 'right',
                        minWidth: 70
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t14'), // 颜色
                        key: 'colour',
                        align: 'center',
                        width: 50
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t15'), // 包装规格/明细
                        key: 'packingDetails',
                        align: 'left',
                        render: (h, params) => {
                            return h('Tooltip', {
                                props: {
                                    content: params.row.packingDetails,
                                    placement: 'top'
                                },
                                class: 'm-tooltip-overflow'
                            }, params.row.packingDetails);
                        },
                        minWidth: 180
                    },
                    {
                        title: this.$t('enameledWireMateBarBind.t16'), // 上传日期
                        key: 'creationDate',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            if (params.row.creationDate) {
                                return h('span', moment(params.row.creationDate).format('YYYY-MM-DD'));
                            }
                        }
                    }
                ]
            },
            tableData: [],
            tableDataCopy: [],
            tableTitle: '',
            loading: false,
            condition: {},
            selection: [],
            list: [],
            orgCode: null,
            itemDeliveryQuantity: null, // 送货单数量
            itemCode: null,
            quantitative: null          // 已绑定数量(默认)
        };
    },
    watch: {},
    methods: {
        onPageChange(currentPage, pageSize, condition) {
            this.settings.currentPage = currentPage;
            this.onSearch();
        },
        /** 页容量改变时触发 */
        onPageSizeChange(currentPage, pageSize, condition) {
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        onSelectionChange (selection) {
            // console.log('selection::', selection);
            this.selection = selection;
            let bindNum = null;
            this.selection.forEach((item) => {
                let m = 0;
                try {
                    m = Math.pow(10, item.quantity.toString().split('.')[1].length);
                } catch (error) {
                    m = 1;
                }
                bindNum = (bindNum * m + Number(item.quantity) * m)/m;
            })
            this.formData.items[2].value = bindNum ? bindNum.toFixed(4) : this.quantitative;
            if (this.selection.length > 0) {
                this.tableButtons.customButtons[0].disabled = false;
            } else {
                this.tableButtons.customButtons[0].disabled = true;
            }
        },
        onSubmit(current, pageSize, condition) {
            this.condition = condition;
            this.settings.currentPage = 1;
            this.settings.pageSize = pageSize;
            this.onSearch();
        },
        /** 搜索 */
        onSearch() {
            let params = {};
            this.formData.items.forEach((item) => {params[item.field] = item.value;});

            params.vendorCode = this.supplierInfo.vendorCode;
            // params.pageNum = this.settings.currentPage;
            // params.pageSize = this.settings.pageSize;
            this.loading = true;
            this.tableButtons.customButtons[0].loading = true;
            this.formData.items[1].value = '';
            this.formData.items[2].value = '';
            this.quantitative = null;
            this.tableData = [];
            axios.post('/gscint/uploadTag/getWaitBindUploadTag', params).then(
                res => {
                    this.loading = false;
                    this.tableButtons.customButtons[0].loading = false;
                    let rep = res.data.data;
                    if (res.data.success) {
                        try {
                            if (rep.code === '1') {
                                this.tableData = rep.datas.list || [];
                                this.tableDataCopy = this.objDeepCopy(this.tableData);
                                this.formData.items[1].value = rep.datas.deliveryQuantity  || '';
                                this.formData.items[2].value = Number(rep.datas.quantity) || '';
                                this.quantitative = Number(rep.datas.quantity) || '';
                                this.itemInfo = rep.datas.itemInfo;
                                this.orgCode = this.itemInfo[0].orgCode;
                                this.itemDeliveryQuantity = this.itemInfo[0].itemDeliveryQuantity;
                                this.itemCode = this.itemInfo[0].itemCode;

                            } else {
                                this.$Modal.error({
                                    title: this.$t('common.warn'),
                                    content: rep.msg
                                });
                            }
                        } catch (err) {
                            console.log('err:', err);
                        }
                    } else {
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: res.data.msg
                        });
                    }
                }
            ).catch(() => {
                this.loading = false;
                this.tableButtons.customButtons[0].loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        /** 本地过滤送货标签条码号 */
        filterData() {
            let val = this.itemTagBarcodeVal.trim();
            if (val) {
                this.loading = true;
                this.tableButtons.customButtons[0].loading = true;
                setTimeout(() => {
                    let arr = [];
                    this.tableDataCopy.forEach(item => {
                        if (item.itemTagBarcode.indexOf(val) > -1) {
                            arr.push(item);
                        }
                    });
                    this.tableData = arr;
                    this.loading = false;
                    this.tableButtons.customButtons[0].loading = false;
                }, 300);
            } else {
                this.onSearch();
            }
        },
        /** 深拷贝 */
        objDeepCopy(source) {
            var sourceCopy = source instanceof Array ? [] : {};
            for (var item in source) {
                if (typeof source[item] === 'object') {
                    if (source[item] === null) {
                        sourceCopy[item] = null;
                    } else {
                        sourceCopy[item] = this.objDeepCopy(source[item]);
                    }
                } else {
                    sourceCopy[item] = source[item];
                }
            }
            return sourceCopy;
        },
        /** 绑定条码之前验证1 */
        beforeBindingBarcode() {
            let params = {};
            params.deliveryBarcode = this.formData.items[0].value;
            this.loading = true;
            this.tableButtons.customButtons[0].loading = true;
            axios.get('/gscint/uploadTag/checkBindTag', {params}).then(
                res => {
                    this.loading = false;
                    this.tableButtons.customButtons[0].loading = false;
                    if (res.data.success) {
                        if (res.data.data.code === '-1') {
                            this.$Modal.confirm({
                                title: this.$t('common.warn'),
                                content: res.data.data.msg,
                                onOk: () => {
                                    setTimeout(() => {
                                        this.bindingBarcode();
                                    }, 30);
                                },
                                onCancel: () => {}
                            })
                        } else if (res.data.data.code === '1') {
                            this.bindingBarcode();
                        } else {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: res.data.data.msg
                            });
                        }
                    } else {
                        this.loading = false;
                        this.tableButtons.customButtons[0].loading = false;
                        this.$Modal.error({
                            title: this.$t('common.warn'),
                            content: res.data.msg
                        });
                    }
                }
            ).catch(() => {
                this.loading = false;
                this.tableButtons.customButtons[0].loading = false;
                this.$Modal.error({
                    title: this.$t('common.warn'),
                    content: this.$t('common.error1')
                });
            });
        },
        /** 绑定条码之前验证2 */
        beforeBindingBarcode2() {
            let isOk = false;
            let mateCodeArr = [];
            this.selection.forEach((each) => {
                mateCodeArr.push(each.itemCode);
            });
            let itemCodes = [];
            this.itemInfo.forEach(({itemCode}) => {
                itemCodes.push(itemCode)
                itemCodes = Array.from(new Set(itemCodes));
            });
            if (itemCodes.length > 1) {
                this.$Modal.warning({
                    content: `${this.$t('enameledWireMateBarBind.t20')}${this.itemTagBarcodeVal}${this.$t('enameledWireMateBarBind.t21')}`
                });
                return false;
            }
            mateCodeArr = Array.from(new Set(mateCodeArr));
            if (mateCodeArr.length === 1 && mateCodeArr.includes(this.itemCode)) {
                isOk = true;
            } else {
                this.$Modal.warning({
                    title: this.$t('common.warn'),
                    content: this.$t('enameledWireMateBarBind.t17')
                });
                isOk = false;
                return false;
            }
            if (this.itemDeliveryQuantity !== Number(this.formData.items[2].value)) {
                this.$Modal.warning({
                    title: this.$t('common.warn'),
                    content: this.$t('enameledWireMateBarBind.t18')
                });
                isOk = false;
                return false;
            } else {
                isOk = true;
            }
            return isOk;
        },
        /** 绑定条码 */
        bindingBarcode() {
            if (this.beforeBindingBarcode2()) {
                let bparam = {};
                let supplierInfo = this.supplierInfo;
                bparam.deliverBarcode = this.formData.items[0].value; // 条码号
                bparam.deliveryQuantity = this.formData.items[1].value; // 送货单总数量
                bparam.operatorName = supplierInfo.userName; // 登录用户名
                bparam.vendorCode = supplierInfo.vendorCode;
                bparam.vendorName = supplierInfo.vendorName;
                bparam.mdmCode = supplierInfo.mdmCode;
                bparam.orgCode = this.orgCode; // 组织编码
                bparam.list = this.selection;
                let url = '/gscint/uploadTag/bindUploadTag';
                this.loading = true;
                this.tableButtons.customButtons[0].loading = true;
                axios.post(url, bparam).then(
                    res => {
                        this.loading = false;
                        this.tableButtons.customButtons[0].loading = false;
                        if (res.data.success === true) {
                            try {
                                if (res.data.data.code === '1') {
                                    this.$Modal.success({
                                        title: this.$t('common.warn'),
                                        content: this.$t('enameledWireMateBarBind.t19')
                                    });
                                    this.formData.items[0].value = '';
                                    this.tableData = [];
                                    this.$closeTab('enameledWireMateBarBind');
                                } else if (res.data.data.code === '-1') {
                                    setTimeout(() => {
                                        this.$Modal.warning({
                                            title: this.$t('common.warn'),
                                            content: res.data.data.msg
                                        });
                                    }, 300);
                                } else {
                                    this.$Modal.error({
                                        title: this.$t('common.warn'),
                                        content: this.$t('common.error1')
                                    });
                                }
                            } catch (err) {
                                console.log('err:', err);
                            }
                        } else {
                            this.$Modal.error({
                                title: this.$t('common.warn'),
                                content: res.data.msg
                            });
                        }
                    }
                ).catch(() => {
                    this.loading = false;
                    this.tableButtons.customButtons[0].loading = false;
                    this.$Modal.error({
                        title: this.$t('common.warn'),
                        content: this.$t('common.error1')
                    });
                });
            }
        }
    },
    mounted () {
        this.supplierInfo = JSON.parse(window.localStorage.supplierInfo); // 获取创建人等信息
        let deliveryBarcode = this.$route.query.barcodes ? JSON.parse(this.$route.query.barcodes) : null;
        this.getFormDataItemObj(this.formData.items, 'deliveryBarcode').value = '';
        this.getFormDataItemObj(this.formData.items, 'deliveryBarcode').value = deliveryBarcode;
    }
};
</script>

<style lang='less' scoped>

</style>